import type { PickDeep } from 'type-fest'
import type { GameModuleOptions } from '@game/types'
import type { PublicGameOptionPath } from '../../publicOptions'
import { useRuntimeConfig } from '#imports'

export const useGameConfig = (): PickDeep<GameModuleOptions, PublicGameOptionPath> => {
    const config = useRuntimeConfig()

    return config.public.game as unknown as PickDeep<GameModuleOptions, PublicGameOptionPath>
}
